/**
 * Component to upload single/multiple files.
 */
import { Button, Upload, message, Typography } from "antd"
import { InboxOutlined } from "@ant-design/icons"
import React, { useState } from "react"
import { saveFile } from "@/api/file.api"

const { Dragger } = Upload

const UploadFiles = ({
  setShowUpload,
  currentPath,
}: {
  setShowUpload: any
  currentPath: string
}): JSX.Element => {
  const [fileList, setFileList] = useState<File[]>([])
  const [uploading, setUploading] = useState<boolean>(false)

  const handleUpload = async () => {
    setUploading(true)

    try {
      await saveFile(currentPath, fileList)
      setUploading(false)
      setFileList([])
      message.success("upload successfully.")
      setShowUpload(false)
    } catch (e) {
      message.error("upload failed.")
      setUploading(false)
    }
  }

  const props = {
    onRemove: (file: File) => {
      const newList = fileList.filter(({ name }) => file.name !== name)
      setFileList([...newList])
    },
    beforeUpload: (file: File) => {
      setFileList((prevState) => [...prevState, file])
      return false
    },
    fileList,
  }

  return (
    <>
      <Typography.Paragraph>Upload to: {currentPath}</Typography.Paragraph>
      {/* @ts-ignore*/}
      <Dragger {...props} multiple height={150}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
      </Dragger>

      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0 || uploading}
        loading={uploading}
        style={{ marginTop: 16, width: "100%" }}
      >
        Upload
      </Button>
    </>
  )
}

export default UploadFiles
